import React, {Component} from 'react';
import ExternalCustomerGeneralInfo from "./components/ExternalCustomerGeneralInfo";
import ExternalCustomerAddressInfo from "./components/ExternalCustomerAddressInfo";
import classnames from 'classnames';
import {Col, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import ExternalCustomerBankInfo from "./components/ExternalCustomerBankInfo";
import Alert from 'react-s-alert';
import Swal from "sweetalert2";
import {deepCopyObject, hasUserRight, showAxiosError, trimObject} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import NavBarKS from "../../components/NavBarKS";
import SquareButtonX from "../../components/SquareButtonX";
import NotifyKS from "../../components/NotifyKS";
import ForeignCompanyGeneralInfo from "./components/ForeignCompanyGeneralInfo";
import {ExternalCustomerMainType, UserRightsEnum} from "../../helper/enums";
import Select from "../../local_node_modules/react-select";
import externalCustomer from "../voucher/component/ExternalCustomer";

class CreateEditExternalCustomer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: {},
			activeTab: '1',
			childValidInfo: false,
			currentTitle: null,
			addressTabModal: false,
			bankTabModal: false,
			isAlertVisible: false,
			customerType: null,
			mode: 'create',
			pkList: [],
			editAddressMode: 'passive',
			editAddressIndex: null,
			externalCustomerBank: {
				recordId: '',
				bankName: '',
				iban: ''
			},
			externalCustomerAddress: {
				recordId: '',
				addressName: '',
				gbAlias: '',
				pkAlias: '',
				countryName: 'Türkiye',
				cityName: '',
				citySubdivisionName: '',
				webSite: '',
				email: '',
				telephone: '',
				fax: '',
				postalAddressRegion: '',
				streetName: '',
				buildingName: '',
				postalAddressRoom: '',
				postalZone: '',
				contactPerson: ''
			},
			externalCustomerAddressList: [],
			externalCustomerBankList: [],
			notify: null,
			countries:[],
			externalCustomerMainType: ExternalCustomerMainType.Normal,
			isLoading : false,
			changeExternalCustomer: false,
		};

		this.onChangeExternalCustomer = this.onChangeExternalCustomer.bind(this);
		this.onChangeExternalCustomerAddress = this.onChangeExternalCustomerAddress.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onPKAliasChange = this.onPKAliasChange.bind(this);
		this.onCitySubdivisionChange = this.onCitySubdivisionChange.bind(this);
		this.onChangeExternalCustomerBank = this.onChangeExternalCustomerBank.bind(this);
		this.getSubdivisionsForCity = this.getSubdivisionsForCity.bind(this);
		this.toggle = this.toggle.bind(this);
		this.fetchValidDataFromChild = this.fetchValidDataFromChild.bind(this);
		this.addAddressToCustomer = this.addAddressToCustomer.bind(this);
		this.addBankToCustomer = this.addBankToCustomer.bind(this);
		this.clearExternalCustomerAddress = this.clearExternalCustomerAddress.bind(this);
		this.clearExternalCustomerBank = this.clearExternalCustomerBank.bind(this);
		this.clearExternalCustomer = this.clearExternalCustomer.bind(this);
		this.fillAddressForm = this.fillAddressForm.bind(this);
		this.fillBankForm = this.fillBankForm.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.deleteAddressFromExternalCustomer = this.deleteAddressFromExternalCustomer.bind(this);
		this.deleteBankFromExternalCustomer = this.deleteBankFromExternalCustomer.bind(this);
		this.onChangeType = this.onChangeType.bind(this);
		this.onChangeRiskLimitOrBalance = this.onChangeRiskLimitOrBalance.bind(this);
		this.checkBeforeSubmit = this.checkBeforeSubmit.bind(this);
		this.editAddress = this.editAddress.bind(this);
		this.defineTabName = this.defineTabName.bind(this);
		this.addNewBank = this.addNewBank.bind(this);
		this.setPkAlias = this.setPkAlias.bind(this);
		this.onCountryChange=this.onCountryChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChangeMainType = this.onChangeMainType.bind(this);
		this.externalCustMainTypes = this.externalCustMainTypes.bind(this);
		this.selectedAddressChange = this.selectedAddressChange.bind(this);

	}

	componentDidMount() {
		let params = {
			url: `/externalCustomer/edit/${this.props.match.params.type}/${this.props.match.params.recordId}`,
			method: 'post'
		};
		request(params)
			.then(response => {
				console.log(response)
				if (response.data.externalCustomer.recordId === null) {
					let customerType = null;

					if (this.props.match.params.type === 'suppliers') {
						customerType = 1
					} else {
						customerType = 2
					}

					this.setState({
						externalCustomer: response.data.externalCustomer,
						cities: response.data.cities,
						countries: response.data.countries,
						mode: 'create',
						customerType
					});
				} else {
					let externalCustomerAddressList = null;
					let externalCustomerBankList = null;

					if (response.data.externalCustomer.externalCustomerAddressList !== null) {
						externalCustomerAddressList = response.data.externalCustomer.externalCustomerAddressList;
					} else {
						externalCustomerAddressList = []
					}

					if (response.data.externalCustomer.externalCustomerBankList !== null) {
						externalCustomerBankList = response.data.externalCustomer.externalCustomerBankList;
					} else {
						externalCustomerBankList = []
					}

					this.setState({
						externalCustomer: response.data.externalCustomer,
						cities: response.data.cities,
						countries: response.data.countries,
						externalCustomerAddressList,
						externalCustomerBankList,
						mode: 'edit',
						initExCustGenData: JSON.stringify(response.data.externalCustomer),
						customerType: response.data.externalCustomer.customerType,
						externalCustomerMainType: response.data.externalCustomer.externalCustomerMainType ? response.data.externalCustomer.externalCustomerMainType : ExternalCustomerMainType.Normal,
					})
				}
			})
			.catch(error => {
				if (error.response && error.response.data && error.response.data.Exception === "Erişim yetkiniz bulunmamaktadır.") {
					showAxiosError(error);
					this.props.history.push('/externalCustomer');
				} else {
					showAxiosError(error);
				}
			});
	}

	onChangeExternalCustomer(e) {
		if (e.target.value.length >= 10 && e.target.value.length <=11){
			let params = {
				url: `/externalCustomer/getTurmobUser`,
				method: 'post',
				data: e.target.value
			};

			request(params)
				.then(response => {
					if (response.data !== undefined && response.data !== null && response.data !== ''){
						this.clearExternalCustomerAddress();
						this.clearExternalCustomer();
						let externalCustomer = response.data;
						if (externalCustomer.city !== null){
							let city = externalCustomer.city.charAt(0) + externalCustomer.city.slice(1).toLowerCase();
							externalCustomer['city'] = city;
						}
						this.setState({externalCustomer: externalCustomer})
						if (response.data.externalCustomerAddressList.length > 0){
							this.setState({externalCustomerAddress: response.data.externalCustomerAddressList[0],
								externalCustomerAddressList: response.data.externalCustomerAddressList,
								changeExternalCustomer: true})
						}
						this.setState({changeExternalCustomer: false})
					} else {
						this.setState({changeExternalCustomer: false})
					}
				})
		}
		this.setState({changeExternalCustomer: false})
		let externalCustomer = deepCopyObject(this.state.externalCustomer);
		externalCustomer[e.target.name] = e.target.value;
		if (e.target.name === "title") {
			this.setState({
				externalCustomer,
				currentTitle: e.target.value
			});
		} else if (e.target.name === "city" && e.target.value === null){
			externalCustomer['taxOffice'] = e.target.value;
		}

		this.setState({
			externalCustomer
		});

		if (this.state.externalCustomer && this.state.externalCustomer.vknTckn) {
			if (this.state.externalCustomer.vknTckn.length === 10) {
				if (this.state.externalCustomer.title != null && e.target.name === "formattedName") {
					this.state.externalCustomer.title = this.state.externalCustomer.formattedName;
				}
			} else if (this.state.externalCustomer.vknTckn.length === 11) {
				if (this.state.externalCustomer.title != null && (e.target.name === "givenName" || e.target.name === "familyName")) {
					this.state.externalCustomer.title = this.state.externalCustomer.givenName + " " + this.state.externalCustomer.familyName;
				}
			}
		}
	}

	clearExternalCustomer(){
		let clearExternalCustomer = {
			buyerType: '',
			city: '',
			commerceChamber: '',
			customer: '',
			customerCode: '',
			customerRiskLimit: '',
			customerType: '',
			externalCustomerAddressList: [],
			externalCustomerBankList: [],
			familyName: '',
			formattedName: '',
			givenName: '',
			initialBalance: '',
			mersisNumber: '',
			middleName: '',
			taxOffice: '',
			recordId: null,
			title: '',
			tradeRegistrationNumber: '',
			vknTckn: ''
		}
		this.setState({externalCustomer: clearExternalCustomer, changeExternalCustomer: true, externalCustomerAddressList: []})
	}

	onCityChange(e) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				cityName: e.value
			}
		})
	}

	onPKAliasChange(e) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				postboxAlias: e.value
			}
		})
	}

	onCitySubdivisionChange(e) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				citySubdivisionName: e.value
			}
		})
	}

	onCountryChange(e){
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				countryName: e.value
			}
		})}

	getSubdivisionsForCity(data) {
		if (data === null) {
			return [];
		}

		if (this.state.externalCustomerAddress.cityName !== '') {
			let city = this.state.cities.find(obj => obj.cityName === data);
			if(city && city["subdivisions"]){
				return city["subdivisions"].map(subdiv => ({
					value: subdiv.name,
					label: subdiv.name
				}))
			}else{
				return [];
			}
		}
	}

	onChangeExternalCustomerAddress(e) {
		if(e.target.name === "email") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		if (e.target && e.target.name && e.target.value && e.target.name === "postalZone" && isNaN(e.target.value)) {
		} else {
			this.setState({
				externalCustomerAddress: {
					...this.state.externalCustomerAddress,
					[e.target.name]:  e.target.value
				}
			})
		}
	}

	setPkAlias(type, alias) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				[type]: alias
			}
		})
	}

	clearExternalCustomerAddress() {
		let externalCustomerAddress = {
			recordId: '',
			addressName: 'MERKEZ',
			gbAlias: '',
			pkAlias: '',
			countryName: 'Türkiye',
			cityName: '',
			citySubdivisionName: '',
			webSite: '',
			email: '',
			telephone: '',
			fax: '',
			postalAddressRegion: '',
			streetName: '',
			buildingName: '',
			postalAddressRoom: '',
			postalZone: '',
			contactPerson: ''
		};
		this.setState({
			externalCustomerAddress,
			editAddressMode: 'passive',
			editAddressIndex: null,
		})
	}

	addAddressToCustomer() {
		let result = this.addressInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let externalCustomerAddressList = deepCopyObject(this.state.externalCustomerAddressList);

				let found = false;
				externalCustomerAddressList.map(eca => {
					if (eca.addressName === this.state.externalCustomerAddress.addressName) {
						found = true;
					}
				});

				if (!found) {
					externalCustomerAddressList.push(this.state.externalCustomerAddress);

					this.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress(), this.addressInfoChild.closeAddAddressModal())
				} else {
					Alert.error('Aynı adlı adres kaydı zaten mevcut.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					})
				}
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
	}

	fillAddressForm(data) {
		this.setState({
			editAddressMode: data.editAddressMode,
			editAddressIndex: data.index,
			externalCustomerAddress: data.row
		})
	}

	deleteAddressFromExternalCustomer(data) {
		let self = this;
		let error = {};
		let addressValidity = this.addressInfoChild.validateComponent();
		let addressInfoError = this.addressInfoChild.state.error;
		for (let key in addressInfoError) {
			error[key] = addressInfoError[key]
		}

		this.setState({
			error
		}, function () {
			if (addressValidity.valid && !(this.state.externalCustomer.externalCustomerAddressList === null ||
				self.state.externalCustomer.externalCustomerAddressList.length === 1)) {

				let recordId = JSON.parse(JSON.stringify(data));
				let params = {
					url: '/externalCustomer/deleteAddress/'+ recordId,
					method: 'post'
				};
				request(params).then(() => {
					Swal({
						title: 'Başarılı ! ',
						text: ("Silme işlemi başarıyla gerçekleştirildi."),
						type: 'success',
						confirmButtonText: 'Tamam'
					});
					let externalCustomerAddressList = deepCopyObject(self.state.externalCustomerAddressList);
					externalCustomerAddressList.splice(externalCustomerAddressList.findIndex(eca => eca.recordId === data),1);
					self.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress())


				}).catch(function (error) {
					showAxiosError(error);
				});

			} else {
				Alert.error("Carinin en az bir adresi olmalıdır.", {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	onChangeExternalCustomerBank(e) {
		let iban;
		if(e.target.name === 'iban'){
			iban = e.target.value.replace(/\s/g, '');
		}
		this.setState({
			externalCustomerBank: {
				...this.state.externalCustomerBank,
					[e.target.name]: e.target.name ==='iban' ? iban :e.target.value} })
	}


	selectedAddressChange(){
		let address = deepCopyObject(this.state.externalCustomerAddress)
		if (address.defaultAddress === true){
			address.defaultAddress = false;
			this.setState({externalCustomerAddress: address})
		}else {
			address.defaultAddress = true;
			this.setState({externalCustomerAddress: address})
		}
	}

	clearExternalCustomerBank() {
		let externalCustomerBank = {
			recordId: '',
			bankName: '',
			iban: ''
		};
		this.setState({
			externalCustomerBank
		})
	}

	 addBankToCustomer() {
		let result = this.bankInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let externalCustomerBankList = deepCopyObject(this.state.externalCustomerBankList);
				externalCustomerBankList.push(this.state.externalCustomerBank);

				this.setState({
					externalCustomerBankList,
					externalCustomer: {
						...this.state.externalCustomer,
						externalCustomerBankList
					}
				}, () => this.clearExternalCustomerBank())
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
	}

	async addNewBank() {
		let self = this;
		let externalCustomerBank = self.state.externalCustomerBank;

		let data = self.state.externalCustomerBank;
		data.externalCustomer = self.state.externalCustomer;
		let params = {
			url: `/externalCustomer/addNewBank`,
			method: 'post',
			data: data
		};
		await request(params)
			.then(function (response) {
				externalCustomerBank.recordId = response.data.recordId;
				self.setState({
					notify: {
						type: 'success',
						message: 'Banka kaydı başarıyla kaydedildi'
					},
					deleteModal: false,
					externalCustomerBank
				})
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	deleteBankFromExternalCustomer(id, index) {
		let recordId = JSON.parse(JSON.stringify(id));
		if (recordId === "") {
			let externalCustomerBankList = deepCopyObject(this.state.externalCustomerBankList);
			externalCustomerBankList.splice(index, 1);
			this.setState({
				externalCustomerBankList: externalCustomerBankList,
				externalCustomer: {
					...this.state.externalCustomer,
					externalCustomerBankList: externalCustomerBankList
				}
			})
		} else {
			let params = {
				url: '/externalCustomer/deleteBank/',
				data: recordId,
				method: 'delete'
			};
			request(params).then(() => {
				Swal({
					title: 'Başarılı ! ',
					text: ("Silme işlemi başarıyla gerçekleştirildi."),
					type: 'success',
					confirmButtonText: 'Tamam'
				})
			}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	fillBankForm(data) {
		this.setState({
			externalCustomerBank: data,
		})
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			})
		}
	}

	defineTabName() {
		if (this.state.activeTab === '1') {
			return 'Adres Bilgileri'
		} else {
			return 'Banka Bilgileri'
		}
	}

	fetchValidDataFromChild(data) {
		this.setState({
			childValidInfo: data.valid
		})
	}

	checkBeforeSubmit() {
		let self = this;
		let error = {};
		let generalValidity = this.generalInfoChild.validateComponent();
		let generalInfoError = this.generalInfoChild.state.error;
		for (let key in generalInfoError) {
			error[key] = generalInfoError[key]
		}

		let addressValidity = this.addressInfoChild.validateComponent();
		let addressInfoError = this.addressInfoChild.state.error;
		for (let key in addressInfoError) {
			error[key] = addressInfoError[key]
		}

		let bankValidity = this.bankInfoChild.validateComponent();
		let bankInfoError = this.bankInfoChild.state.error;
		for (let key in bankInfoError) {
			error[key] = bankInfoError[key]
		}

		this.setState({
			error
		}, function () {
			if ((generalValidity.valid && addressValidity.valid && bankValidity.valid) && !(this.state.externalCustomer.externalCustomerAddressList === null ||
				self.state.externalCustomer.externalCustomerAddressList.length === 0)) {
				self.handleSubmit();
			} else {
				Alert.error(self.arrangeErrorMessage(), {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	handleSubmit() {
		let self = this;
		const data = trimObject(this.state.externalCustomer);
		data.customerType = this.state.customerType;
		data.externalCustomerMainType = this.state.externalCustomerMainType;
		self.setState({isLoading : true});
		let params = {
			url: `/externalCustomer/create`,
			data: data,
			method: 'post'
		};
		request(params).then(() => {
			if (this.props.match.params.type === 'suppliers') {
				this.props.history.push(`/suppliers`)
			} else {
				this.props.history.push(`/externalCustomer`)
			}
			Alert.success('Başarıyla Kaydedildi !', {
				html: true,
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			})
		})
			.catch(function (error) {
				self.setState({isLoading : false});
				showAxiosError(error);
			});
	}

	isChanged(initState, input) {
		if (this.state.mode === 'create') {
			return false
		} else {
			if (initState === JSON.stringify(input)) {
				return false
			} else {
				return true
			}
		}
	}

	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);

		let errorArray = [];

		if (this.state.externalCustomer.externalCustomerAddressList === null || this.state.externalCustomer.externalCustomerAddressList.length === 0) {
			let error = {};
			error.field = '*';
			error.message = 'En Az Bir Adres Belirtilmeden Cari Kaydedilemez';
			errorArray.push(error)
		}

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message && key !== 'tCity') {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tVknTckn':
				return 'Vkn/Tckn ';
			case 'tFormattedName':
				return 'Unvan ';
			case 'tGivenName':
				return 'Adı ';
			case 'tFamilyName':
				return 'Soyadı ';
			case 'tTaxOffice':
				return 'Vergi Dairesi ';
			case 'tMiddleName':
				return 'Orta Adı ';
			case 'tTitle':
				return 'Firma Adı ';
			default :
				return '';
		}
	}


	onChangeType(e) {
		let externalCustomer = this.state.externalCustomer;
		externalCustomer.customerType = e.value;
		this.setState({externalCustomer, customerType: e.value})
	}

	onChangeRiskLimitOrBalance(e) {
		let externalCustomer = this.state.externalCustomer;
		externalCustomer[e.name] = e.value;
		this.setState({externalCustomer});
	}

	onChangeMainType(e) {
		let externalCustomer = this.state.externalCustomer;
		let externalCustomerMainType = this.state.externalCustomerMainType;

		if(externalCustomerMainType !== e.value){
			externalCustomerMainType = e.value;
			if(externalCustomerMainType === ExternalCustomerMainType.DespatchMixed){
				externalCustomer["vknTckn"] = "55555555555";
			}else{
				externalCustomer["vknTckn"] = "";
			}
			externalCustomer["externalCustomerMainType"] = externalCustomerMainType;
			this.setState({externalCustomer,externalCustomerMainType});
		}
	}

	editAddress() {
		let result = this.addressInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let address = deepCopyObject(this.state.externalCustomerAddress);
				let externalCustomerAddressList = deepCopyObject(this.state.externalCustomerAddressList);
				let index = deepCopyObject(this.state.editAddressIndex);

				let found = false;
				externalCustomerAddressList.map(eca => {
					if (eca.addressName === address.addressName && eca.recordId !== address.recordId) {
						found = true;
					}
				});

				if (!found) {
					externalCustomerAddressList.splice(index, 1, address);
					this.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress(), this.addressInfoChild.closeAddAddressModal())
				} else {
					Alert.error('Aynı adlı adres kaydı zaten mevcut.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					})
				}

			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	externalCustMainTypes(){
		return [
		        {label: "T.C. Vatandaşı", value: ExternalCustomerMainType.Normal},
				{label: "Yabancı", value: ExternalCustomerMainType.Foreign},
				{label: "E-İrsaliye Muhtelif", value: ExternalCustomerMainType.DespatchMixed}
				];
	}

	render() {
		const externalCustMainTypes = this.externalCustMainTypes();

		if (this.state.externalCustomer === undefined)
			return (<div className="row">Yükleniyor...</div>);

		return (
			<div className="row baseBackground">

				<NavBarKS>
					<SquareButtonX position="leftSide"
								   disabled={(this.state.externalCustomer && this.state.externalCustomer.recordId
									   ? !hasUserRight(UserRightsEnum.settings.externalCustomer.update,this.props.currentUser)
									   : !hasUserRight(UserRightsEnum.settings.externalCustomer.create,this.props.currentUser)) ||
								   		this.state.isLoading}
								   img="save.png"
								   onClick={() => this.checkBeforeSubmit()} label="Kaydet"/>
				</NavBarKS>

				<div className="satirBasi col-sm-12">
					<div className=" ">
					<div className="col-sm-6 row">
						<div className="col-sm-1">
							<Label  style={{marginLeft: '-5px', marginTop: '8px', textAlign:'left'}}>
								Tip:
							</Label>
						</div>
						<div className="col-sm-5" style={{marginTop: '5px',marginBottom:'5px'}}>
							<Select
								value={this.state.externalCustomerMainType}
								clearable={false}
								placeholder="Seçiniz..."
								onChange={(e) => this.onChangeMainType(e)}
								options={externalCustMainTypes}/>
						</div>
					</div>
						<div className="card-header">
							<h4 className="card-title" style={{marginLeft: '-10px',marginBottom:'-5px'}}>
								{
									(this.state.externalCustomerMainType === ExternalCustomerMainType.Normal) ? 'Müşteri Bilgileri' :
									(this.state.externalCustomerMainType === ExternalCustomerMainType.Foreign) ? 'Yabancı Müşteri Bilgileri' : 'E-İrsaliye Muhtelif Müşteri Bilgileri'
								}
							</h4>
						</div>
						<div className=" satirBasi FormRenk" style={{marginTop: '0px'}}>
							{(this.state.externalCustomerMainType === ExternalCustomerMainType.Normal || this.state.externalCustomerMainType === ExternalCustomerMainType.DespatchMixed) &&
							<div className="card-header ">
								<ExternalCustomerGeneralInfo
									ref={instance => {
										this.generalInfoChild = instance
									}}
									externalCustomer={this.state.externalCustomer}
									requiredTaxOffice={false}
									size={12}
									marginTop={-20}
									cities={this.state.cities}
									onChangeExternalCustomer={this.onChangeExternalCustomer}
									type={this.props.match.params.type}
									onChangeType={this.onChangeType}
									customerType={this.state.customerType}
									onChangeRiskLimitOrBalance={this.onChangeRiskLimitOrBalance}
									externalCustomerMainType={this.state.externalCustomerMainType}
									changeExternalCustomer={this.state.changeExternalCustomer}
									switch/>

							</div>
							}
							{ this.state.externalCustomerMainType === ExternalCustomerMainType.Foreign &&
							<div className="card-header ">
								<ForeignCompanyGeneralInfo
									ref={instance => {
									this.generalInfoChild = instance
								}}
														   externalCustomer={this.state.externalCustomer}
														   requiredTaxOffice={false}
														   size={12}
														   marginTop={-20}
														   cities={this.state.cities}
														   onChangeExternalCustomer={this.onChangeExternalCustomer}
														   type={this.props.match.params.type}
														   onChangeType={this.onChangeType}
														   customerType={this.state.customerType}
														   onChangeRiskLimitOrBalance={this.onChangeRiskLimitOrBalance}
														   switch/>

							</div>
							}

						</div>
						<div className="card-nav-tabs">
							<div className="">

								<div className="card-header card-header-danger">
									<h4 className="card-title">{this.defineTabName()}</h4>
								</div>

								<div className="col-sm-12">
									<Nav pills className="nav-pills-primary">
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '1'})}
												onClick={() => {
													this.toggle('1');
												}}
											>
												Adres Bilgileri
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '2'})}
												onClick={() => {
													this.toggle('2');
												}}
											>
												Banka Bilgileri
											</NavLink>
										</NavItem>
									</Nav>

									<hr style={{marginBottom: '20px'}}></hr>
									<div className="card-body">

										{this.state.notify &&
										<Row>
											<NotifyKS
												type={this.state.notify.type}
												message={this.state.notify.message}
												html={this.state.notify.html}
												timeout={this.state.notify.timeout}
												autohide={this.state.notify.autohide}
											/>
										</Row>}

										<TabContent activeTab={this.state.activeTab}>
											<TabPane tabId="1">
												<Row>
													<Col sm="12">
														<ExternalCustomerAddressInfo ref={instance => {this.addressInfoChild = instance}}
																					 showDeleteBtn={true}
																					 externalCustomer={this.state.externalCustomer}
																					 onChangeExternalCustomerAddress={this.onChangeExternalCustomerAddress}
																					 onCityChange={this.onCityChange}
																					 onPKAliasChange={this.onPKAliasChange}
																					 onCitySubdivisionChange={this.onCitySubdivisionChange}
																					 getSubdivisionsForCity={this.getSubdivisionsForCity}
																					 currentTitle={this.state.currentTitle}
																					 externalCustomerAddress={this.state.externalCustomerAddress}
																					 addAddressToCustomer={this.addAddressToCustomer}
																					 externalCustomerAddressList={this.state.externalCustomerAddressList}
																					 cities={this.state.cities}
																					 editAddressMode={this.state.editAddressMode}
																					 fillAddressForm={this.fillAddressForm}
																					 clearForm={this.clearExternalCustomerAddress}
																					 editAddress={this.editAddress}
																					 docType='undefined'
																					 setPkAlias={this.setPkAlias}
																					 countries={this.state.countries}
																					 onCountryChange={this.onCountryChange}
																					 deleteAddress={this.deleteAddressFromExternalCustomer}
																					 selectedAddressChange={this.selectedAddressChange}
																					 changeExternalCustomer={this.state.changeExternalCustomer}
														//							 isForeign={this.state.isForeign}
														/>
													</Col>
												</Row>
											</TabPane>

											<TabPane tabId="2">
												<Row>
													<Col sm="12">
														<ExternalCustomerBankInfo ref={instance => {
															this.bankInfoChild = instance
														}}
																				  externalCustomer={this.state.externalCustomer}
																				  currentTitle={this.state.currentTitle}
																				  onChangeExternalCustomerBank={this.onChangeExternalCustomerBank}
																				  externalCustomerBank={this.state.externalCustomerBank}
																				  addBankToCustomer={this.addBankToCustomer}
																				  externalCustomerBankList={this.state.externalCustomerBankList}
																				  fillBankForm={this.fillBankForm}
																				  clearForm={this.clearExternalCustomerBank}
																				  deleteBank={this.deleteBankFromExternalCustomer}
																				  changeExternalCustomer={this.state.changeExternalCustomer}/>
													</Col>
												</Row>
											</TabPane>
										</TabContent>
									</div>

									{/*<div className="row">*/}
									{/*<nav className="col-sm-12">*/}
									{/*<button type="button" data-toggle="tooltip" data-placement="bottom"*/}
									{/*style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}*/}
									{/*rel="tooltip" className="TekBtn kaydet btn-sm btn-icon"*/}
									{/*onClick={() => {*/}
									{/*this.handleSubmit()*/}
									{/*}}>Müşteriyi Kaydet*/}
									{/*</button>*/}
									{/*</nav>*/}
									{/*</div>*/}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default CreateEditExternalCustomer;

